import z from 'zod';

export const zMapStyle = z.enum(['BASIC', 'SATELLITE']);

export const MapStyle = zMapStyle.enum;
export type MapStyle = z.infer<typeof zMapStyle>;
